import { render, staticRenderFns } from "./remark.vue?vue&type=template&id=af10fa68"
import script from "./remark.vue?vue&type=script&lang=ts"
export * from "./remark.vue?vue&type=script&lang=ts"
import style0 from "./remark.vue?vue&type=style&index=0&id=af10fa68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports